/* Bored George - "Personalise your case" on quick-add.

   Same shape as personalise-pdp.js and for the same reasons: the click is
   caught before the theme's own form handler runs, the shopper answers once,
   and the sunglasses plus the case go to the cart in a SINGLE request. No
   second cart call, no timers, no half-added carts. If the request fails the
   click is handed straight back to the theme's form, so a broken upsell can
   never stop someone buying.

   Two quick-add paths converge here:

     1. Single-variant cards render a submit button inside the card's own
        product-form-component.
     2. Multi-variant cards render a type="button" control that opens the
        theme's quick-add dialog; the real add is a submit button inside that
        dialog, which renders the product's FULL buy-buttons block.

   Both end as [name="add"][type="submit"] inside a product-form-component
   carrying data-product-id, which is the one thing this file matches on. The
   product's title, image and prices are then read from the card that
   quick-add.liquid marked eligible - looked up by that same product id, so
   the dialog path works even though the dialog carries no card data.

   HOW THIS AVOIDS FIGHTING personalise-pdp.js: not by looking for
   .buy-buttons-block. The quick-add dialog renders one of those too, so that
   test skipped the dialog and shoppers got no prompt. The real difference is
   whether the panel inside that block has been INITIALISED - personalise-pdp.js
   stamps data-ready="true" on the one it owns. The dialog's copy is injected
   after that script has booted, so it never gets stamped, and this file picks
   it up. If the theme ever changes and the dialog's panel does get
   initialised, this file steps back on its own.

   CLOSING THE SIZE DIALOG. Because this file cancels the theme's submit
   handler, the theme never closes its own dialog - we have to, or it is left
   sitting on screen behind the cart drawer after the add. It is closed at
   HANDOVER, the moment the panel opens, so there is only ever one modal up and
   the dialog cannot outlive a slow or failed cart request, and again after the
   add as a backstop.

   Do not "improve" this by clicking the dialog's own close button. It carries
   on:click="/closeDialog", but a scripted click on it does nothing - measured,
   the dialog stayed open. Only dialog.close() actually shuts it.

   BACKING OUT IS NOT CANCELLING. The shopper reached this panel by pressing
   Add to cart, so the pair is already asked for; only the case is in question.
   The X, the backdrop and Escape therefore all run dismiss(), which does
   exactly what Skip does - adds the pair, no case. close() on its own is only
   for paths where the cart has already been dealt with (after a successful
   add, or after handing the click back to the theme). Wiring an exit straight
   to close() is the bug this replaced: the panel vanished and nothing was
   added. */
(function () {
  'use strict';

  var panel = null;
  var cfg = {};
  var busy = false;
  var bypass = false;
  var pending = null;

  var nameEl, thumbEl, inputEl, priceEl, addBtn, skipBtn, errorEl, rowEl;

  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0];
    var grouped = '';
    while (whole.length > 3) {
      grouped = ',' + whole.slice(-3) + grouped;
      whole = whole.slice(0, -3);
    }
    return '$' + whole + grouped + '.' + parts[1];
  }

  function cleanInitials(raw) {
    var upper = (raw || '').toUpperCase();
    var out = '';
    for (var i = 0; i < upper.length; i++) {
      var ch = upper.charAt(i);
      if (ch >= 'A' && ch <= 'Z') out += ch;
    }
    return out;
  }

  /* "41136412327994:18900,41136412360762:18900" - a compact map rather than
     JSON, so the attribute stays small on every card. */
  function parsePrices(str) {
    var map = {};
    (str || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length === 2) map[bits[0].trim()] = parseInt(bits[1], 10);
    });
    return map;
  }

  function cardFor(productId) {
    if (!productId) return null;
    return document.querySelector('[data-bgqa-id="' + productId + '"]');
  }

  function shutThemeDialog() {
    var dlg = document.querySelector('dialog.quick-add-modal');
    if (dlg && dlg.open && typeof dlg.close === 'function') {
      try { dlg.close(); } catch (e) { /* already closing */ }
    }
  }

  function closeThemeDialog() {
    shutThemeDialog();
    /* The theme re-renders this dialog on variant change and after cart
       events. One late check catches a re-open landing just after we shut it. */
    setTimeout(shutThemeDialog, 450);
  }

  function casesTotal() {
    if (!pending || !inputEl || !inputEl.value) return 0;
    var first = cfg.firstPrice || 0;
    var extra = cfg.extraId ? (cfg.extraPrice || 0) : first;
    return first + (Math.max(0, pending.qty - 1) * extra);
  }

  function unitPrice() {
    if (!pending) return 0;
    var p = pending.prices[String(pending.variantId)];
    return typeof p === 'number' ? p : 0;
  }

  function paint() {
    var on = !!(inputEl && inputEl.value);
    if (rowEl) rowEl.dataset.on = on ? 'true' : 'false';
    if (priceEl) priceEl.textContent = on ? money(casesTotal()) : '';
    if (addBtn) {
      var total = (unitPrice() * (pending ? pending.qty : 1)) + casesTotal();
      addBtn.textContent = total > 0
        ? (cfg.addLabel || 'Add to cart') + ' · ' + money(total)
        : (cfg.addLabel || 'Add to cart');
    }
  }

  function open(form, card, fromDialog) {
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;

    /* Read everything off the form BEFORE the dialog is shut - it takes the
       form with it. */
    pending = {
      form: form,
      variantId: idEl ? idEl.value : '',
      qty: qty > 0 ? qty : 1,
      title: card.dataset.bgqaTitle || 'Sunglasses',
      image: card.dataset.bgqaImage || '',
      prices: parsePrices(card.dataset.bgqaPrices),
      fromDialog: !!fromDialog
    };

    if (nameEl) nameEl.textContent = pending.title;
    if (thumbEl) thumbEl.style.backgroundImage = pending.image ? 'url(' + pending.image + ')' : '';
    if (inputEl) {
      inputEl.value = '';
      inputEl.setAttribute('aria-label', 'Initials for ' + pending.title);
    }
    if (errorEl) errorEl.hidden = true;
    if (addBtn) addBtn.dataset.busy = 'false';

    paint();
    panel.hidden = false;
    document.body.style.overflow = 'hidden';

    if (fromDialog) closeThemeDialog();
  }

  function close() {
    panel.hidden = true;
    document.body.style.overflow = '';
  }

  /* The shopper pressed Add to cart to get here, so backing out of the panel
     declines the CASE, not the sunglasses. Identical to Skip. The panel is
     hidden first so the exit feels immediate; the cart request carries on
     behind it and opens the drawer when it lands. */
  function dismiss() {
    if (busy) return;
    if (!pending) { close(); return; }
    close();
    submit(false);
  }

  function cartAddUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';
  }

  function afterAdd() {
    close();
    closeThemeDialog();
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (typeof window.unicornOpenCart === 'function') {
      window.unicornOpenCart();
    } else {
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }
  }

  /* Last resort: the upsell failed, so at least get the sunglasses in. */
  function addPairOnly() {
    if (!pending) { close(); return; }
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(pending.variantId, 10), quantity: pending.qty }] })
    })
      .then(function () { afterAdd(); })
      .catch(function () {
        close();
        if (errorEl) {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
        }
      });
  }

  function handBackToTheme() {
    if (!pending) { close(); return; }
    var form = pending.form;
    /* On the dialog path the form went with the dialog, so submitting it would
       do nothing. Add the pair directly instead. */
    if (!document.contains(form)) {
      addPairOnly();
      return;
    }
    bypass = true;
    close();
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
    setTimeout(function () { bypass = false; }, 1500);
  }

  function submit(withCase) {
    if (busy || !pending) return;
    busy = true;
    if (addBtn) addBtn.dataset.busy = 'true';
    if (errorEl) errorEl.hidden = true;

    var q = pending.qty;
    var initials = (withCase && inputEl) ? inputEl.value : '';
    var items = [{ id: parseInt(pending.variantId, 10), quantity: q }];

    if (initials) {
      items.push({
        id: parseInt(cfg.firstId, 10),
        quantity: 1,
        properties: { 'Initials': initials, 'For': pending.title }
      });
      if (q > 1 && cfg.extraId) {
        items.push({
          id: parseInt(cfg.extraId, 10),
          quantity: q - 1,
          properties: { 'Initials': initials, 'For': pending.title }
        });
      }
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        afterAdd();
      })
      .catch(function () {
        handBackToTheme();
      })
      .finally(function () {
        busy = false;
        if (addBtn) addBtn.dataset.busy = 'false';
      });
  }

  function boot() {
    panel = document.querySelector('[data-bgqa-panel]');
    if (!panel || panel.dataset.ready === 'true') return;

    try { cfg = JSON.parse(panel.dataset.config || '{}'); } catch (e) { return; }
    if (!cfg.firstId) return;

    panel.dataset.ready = 'true';

    rowEl = panel.querySelector('.bgp__row');
    nameEl = panel.querySelector('[data-bgqa-name]');
    thumbEl = panel.querySelector('[data-bgqa-thumb]');
    inputEl = panel.querySelector('[data-bgqa-input]');
    priceEl = panel.querySelector('[data-bgqa-price]');
    addBtn = panel.querySelector('[data-bgqa-add]');
    skipBtn = panel.querySelector('[data-bgqa-skip]');
    errorEl = panel.querySelector('[data-bgqa-error]');

    if (inputEl) {
      inputEl.addEventListener('input', function () {
        this.value = cleanInitials(this.value);
        paint();
      });
    }
    if (addBtn) addBtn.addEventListener('click', function () { submit(true); });
    if (skipBtn) skipBtn.addEventListener('click', function () { submit(false); });

    /* X and backdrop. dismiss(), never close() - see the note at the top. */
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-bgqa-close]')) dismiss();
    });

    document.addEventListener('keydown', function (e) {
      if (!panel.hidden && e.key === 'Escape') dismiss();
    });

    /* Capture phase, before the theme's own submit handler. */
    document.addEventListener('click', function (e) {
      if (bypass || busy) return;
      if (!panel || !panel.hidden) return;

      var btn = e.target.closest('[name="add"]');
      if (!btn || btn.disabled) return;
      /* The multi-variant card control is type="button" and only opens the
         theme's size dialog - it never reaches the cart, so leave it alone. */
      if (btn.type !== 'submit') return;

      /* Defer to personalise-pdp.js wherever it has actually taken ownership.
         See the note at the top: presence of .buy-buttons-block is not the
         test, an initialised panel inside it is. */
      var block = btn.closest('.buy-buttons-block');
      if (block && block.querySelector('[data-bgpdp][data-ready="true"]')) return;

      var pfc = btn.closest('product-form-component');
      if (!pfc) return;

      var card = cardFor(pfc.dataset.productId);
      if (!card) return;

      var form = btn.closest('form');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      open(form, card, !!btn.closest('dialog.quick-add-modal'));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
